import { Response } from "@/shared/models/Response";
import axios from "axios";
import { ActionPlanResponseChart } from "../models/ActionPlanResponseChart.model";
import { ActionPlanQuery } from "../models/ActionPlanQuery.model";
import { ActionPlan } from "../models/ActionPlan.model";

export class ActionPlanService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/action-plan`;
  }

  async getActionPlanByQuery(
    query: ActionPlanQuery
  ): Promise<Response<ActionPlanResponseChart>> {
    const serviceURL = `${this.baseUrl}/get-by-filters-arrays`;
    const response = await axios.get(serviceURL, { params: query });
    return response?.data;
  }

  async getActionPlanById(id: string): Promise<Response<ActionPlan>> {
    const serviceURL = `${this.baseUrl}/data/${id}`;
    const response = await axios.get(serviceURL);
    return response?.data;
  }

  async addActionPlan(
    actionPlan: ActionPlan
  ): Promise<Response<string | void>> {
    const response = await axios.post(this.baseUrl, actionPlan);
    return response?.data;
  }

  async updateActionPlanById(
    id: string,
    actionPlan: ActionPlan
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceUrl, actionPlan);
    return response?.data;
  }

  async updateStateActionPlanById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response?.data;
  }

  async deleteActionPlan(id: string): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/${id}`;
    const response = await axios.delete(serviceUrl);
    return response?.data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameActionPlan: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }
}
